// Supported skeleton types
export enum SkeletonType {
  Fox = 'fox',
  Human = 'human',
  Bird = 'bird',
  Dragon = 'dragon',
  Kaiju = 'kaiju',
  Spider = 'spider',
  Snake = 'snake',
  Fish = 'fish',
  Error = 'error',
  None = 'none'
}

// Hand skeleton variation types for human skeleton
export enum HandSkeletonType {
  AllFingers = 'all-fingers',
  ThumbAndIndex = 'thumb-and-index',
  SimplifiedHand = 'simplified-hand',
  SingleBone = 'single-bone'
}
